import Component from '../Component';
export default class VerificationPopup extends Component {

  constructor(theme, element) {
    super(theme, element);

    this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10);
    this.ageDelay = 0;
    this.ageTestMode = this.element.dataset.ageTestMode === 'true';
    this.enterButton = element.querySelector('#button__enter');
    this.exitButton = element.querySelector('#button__exit');
    this.returnButton = element.querySelector('#button__return');
    this.modalLinks = element.querySelector('.modal-content__wrapper a');

    this.load();
  }

  load = () => {

    // Age checker is in test mode - will show immediately in editor and on live site
    if(this.ageTestMode) this.showModal();

    if(this.modalLinks) {
      this.modalLinks.setAttribute('tabindex', '1');
    }

    var isAnAdult = this.readCookie('isAnAdult');
    if (!isAnAdult) {
      if (window.Shopify.designMode && !this.ageTestMode) return;
      this.showModal();
    }

    if(this.enterButton) {
      this.enterButton.addEventListener('click', this.writeCookie);
    }

    if(this.exitButton) {
      this.exitButton.addEventListener('click', this.comeBackModal);
    }

    if(this.returnButton) {
      this.returnButton.addEventListener('click', this.confirmAgeModal);
    }
  }

  writeCookie = () => {
    document.cookie = "isAnAdult=true; expires=0; path=/";
    this.hideModal();
  }

  getModalContent = () => {
    this.changeContent = document.querySelector('.modal-deny-content');
    this.hideInitial = document.querySelector('.modal-initial-content');
  }

  trapFocus = () => {
    setTimeout(() => {
      const container = document.querySelector('.verification-popup-container');
      if(container) {
        const focusableElements = container.querySelectorAll('button, a');
        const visibleElements = Array.from(focusableElements).filter(el => el.offsetParent !== null);
        const firstInput = visibleElements[0];
        const lastInput = visibleElements[visibleElements.length - 1];

        // Set focus on first input
        firstInput.focus();

        // Redirect last tab to first input
        lastInput.addEventListener('keydown', function (e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            firstInput.focus();
          }
        });

        // Redirect first shift+tab to last input
        firstInput.addEventListener('keydown', function (e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            lastInput.focus();
          }
        });
      }
    }, 250);
  }

  readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0 ; i < ca.length ; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  showModal = () => {
    const container = document.querySelector('.verification-popup-container');
    if (container) {
      container.style.display = 'block';
    }
    this.trapFocus();
    document.body.style.overflow = "hidden";
  }

  hideModal = () => {
    const container = document.querySelector('.verification-popup-container');
    if (container) {
      container.style.display = 'none';
    }
    document.body.style.overflow = '';
  }

  /**
   * Shared method to reset scroll and retrieve modal content
   */
  resetScrollAndGetContent = () => {
    const prompt = document.getElementById('verification__prompt');
    if (prompt) {
      prompt.scrollTop = 0;
    }
    this.getModalContent();
  }

  confirmAgeModal = () => {
    this.resetScrollAndGetContent();
    this.changeContent.classList.add('hidden');
    this.hideInitial.classList.remove('hidden');
    this.trapFocus();
  }

  comeBackModal = () => {
    this.resetScrollAndGetContent();
    this.changeContent.classList.remove('hidden');
    this.hideInitial.classList.add('hidden');
    this.trapFocus();
  }
}
